<template lang="pug">
  v-hover(v-if='team' v-slot:default="{ hover }")
    v-card.card-style(:class="{ zoomEfect: hover, 'margin-help-sc': num % 2 === 0 }" )
      v-row.row-name-style(v-if="$vuetify.breakpoint.width > MAX_WIDTH")
        .name-team.text-none {{team.name}}
        v-spacer
        .name-IThierarchy.text-uppercase {{team.it_hierarchy}}
      template(v-else)
        v-row.row-name-style
          .name-team.text-none {{team.name}}
        v-row.mt-3.ml-8
          .name-IThierarchy.text-uppercase {{team.it_hierarchy}}
      p.sub-text.text--disabled.mt-3.ml-8 {{team.count_employee}}
      v-row.ml-8
        v-card.card-mony.elevation-0
          p.text от
          p.mony-text {{ team.price }}
          p.mony-text.ml-1
            font-awesome-icon.icon-tc(:icon="['fas', 'ruble-sign']")
      v-row.group-technology.ml-6.mb-4
        v-chip.chip-technology.text-uppercase(
          v-for="technology in team.technologys"
          small
          ) {{technology.name}}
      v-card-actions.justify-end.d-flex
        v-row.row-footer-style
          template(v-for="(technology, i) in team.technologys")
            v-img.img-normal(v-if="technology.is_show && i<3" :src="technology.get_image" contain)
          v-spacer
          v-btn.text-capitalize.btn-style(@click="booking")
            | Забронировать
</template>

<script>

export default {
  name: "Development",
  props: {
    team: {
      type: Object,
      default: () => {}
    },
    num: {
      type: Number,
      default: () => 0
    },
    isSwiper: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      MAX_WIDTH: 1700,
    }
  },
  methods: {
    booking () {
      this.$emit('onBooking', this.team.name)
      this.$vuetify.goTo('#registration', {offset:-20})
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "scss/variables.scss"
  @import "scss/colors.scss"

  @media (min-width: $mdAndUp)
    .row-name-style
      margin-top: 40px

  @media (min-width: $mdOnlyStart) and (max-width: $mdOnlyEnd)
    .group-technology
      height: 100px

  @media (min-width: $lgOnlyStart) and (max-width: $lgOnlyEnd)
    .group-technology
      height: 85px

  @media (min-width: $lgAndUp)
    .card-style
      padding-left: 4px
      margin-top: 24px

  @media(min-width: $xl)
    .group-technology
      height: 78px

  .card-style
    position: relative
    border-radius: 20px !important
    margin-bottom: 2%
    width: 48%
    min-width: 360px
    box-shadow: 2px -1px 25px $foneCard, 2px 12px 15px $foneCard !important

  .img-normal
    background-size: contain
    background-position: center
    max-width: 50px
    max-height: 50px
    margin-left: 0
    margin-right: 12px

  .name-team
    font-family: GothamProMedium
    font-style: normal
    font-weight: 400
    line-height: 120%
    font-size: min(calc(21px + 0.7vw), 35px)

  .name-IThierarchy
    font-family: GothamProMedium
    font-size: min( calc(12px + 0.4vw), 18px)
    color: $blueBasic
    margin-right: 7%
    margin-top: 1%
    padding-right: 7px

  .row-name-style
    margin-left: 32px

  .sub-text
    font-family: GothamProMedium
    font-size: min(calc(13px + 0.3vw), 18px)

  .card-mony
    color: $blueBasic
    display: flex
    max-width: 200px
    width: 100%
    .text
      font-family: GothamProMedium
      font-size: 18px
      justify-content: center
      align-content: center
      margin-top: 6%
      margin-right: 5px
      display: grid
      margin-bottom: 0

    .mony-text
      font-family: GothamProMedium
      font-size: 18pt
      justify-content: center
      margin-top: 5%
      margin-bottom: 0

  .icon-tc
    margin-bottom: 1px
    font-size: 20px
    font-family: GothamProMedium
    color: $blueBasic

  .group-technology
    display: flex
    flex-wrap: wrap
    justify-content: left
    margin-right: 7%
    .chip-technology
      font: 12px GothamProClassic
      margin-top: 2%
      margin-left: 8px
      background: $chipFont

  .btn-style
    margin-top: 15px
    elevation: 0
    color: $white
    font: $btnFont
    background: $btnColor
    letter-spacing: 0.01em
    width: 191px
    margin-right: 7%

  .zoomEfect
    transform: scale(1.01)

  .margin-help-sc
    margin-right: auto

  .row-footer-style
    margin-left: 24px !important
    margin-bottom: 35px !important
    margin-top: 1px

</style>